
import {
  computed,
  ComputedRef,
  defineComponent,
  onBeforeMount,
  reactive
} from "vue";
import { Course, User } from "../../../../../domain/entities/entities";
import { dispatchError } from "../../../utils/error_handling";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { wrapLoading } from "../../../utils/wrap_loading";
import DropdownContent from "../data-table/DropdownContent.vue";
import Dropdown from "../data-table/Dropdown.vue";
import PersonPhoto from "../data-table/PersonPhoto.vue";
import ProgressBar from "../ProgressBar.vue";

export default defineComponent({
  components: { ProgressBar, PersonPhoto, Dropdown, DropdownContent },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const usersByIndication = reactive(new Map<number, User[]>());

    onBeforeMount(async () => {
      await wrapLoading(async () => {
        await listIndicationCourses();
        const courseID = Number(route.params.courseID);
        if (courseID) {
          await loadIndicationByUsers(courseID);
        }
      });
    });

    const indications: ComputedRef<Course[]> = computed(() => {
      return store.getters["course_module/indicationCourses"];
    });

    const listIndicationCourses = async (): Promise<void> => {
      try {
        await store.dispatch("course_module/listIndicationsCourses");
      } catch (e) {
        await dispatchError(e);
      }
    };

    const loadIndicationByUsers = async (courseID: number): Promise<void> => {
      if (usersByIndication.has(courseID)) return;
      try {
        await wrapLoading(async () => {
          await store.dispatch("course_module/loadIndicationByUsers", courseID);
          const users: User[] = store.getters["course_module/indicationUsers"];
          usersByIndication.set(courseID, users);
        });
      } catch (e) {
        await dispatchError(e);
      }
    };

    const goToCourse = (courseID: number) => {
      router.push({ name: "course", params: { course_id: courseID } });
    };

    return {
      indications,
      loadIndicationByUsers,
      usersByIndication,
      goToCourse
    };
  }
});
